export const getShipmentListTab = (initialFilter = {}) => {
  // Get date in India timezone (UTC+05:30)
  const getIndiaDate = (offsetDays = 0) => {
    const now = new Date();
    const indiaOffset = 5.5 * 60 * 60 * 1000; // +05:30 in milliseconds
    const indiaTime = new Date(now.getTime() + indiaOffset);

    if (offsetDays !== 0) {
      indiaTime.setUTCDate(indiaTime.getUTCDate() + offsetDays);
    }

    const year = indiaTime.getUTCFullYear();
    const month = String(indiaTime.getUTCMonth() + 1).padStart(2, '0');
    const day = String(indiaTime.getUTCDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };

  const today = getIndiaDate(0);
  const nextDayStr = getIndiaDate(1);

  return {
    field: 'preset',
    isPreset: true,
    defaultTab: 'new',
    tabs: [
      {
        key: 'new',
        label: 'New',
        preset: {
          ...initialFilter,
          shipment_status: ['created', 'picking', 'picked'],
        },
      },
      {
        key: 'packed',
        label: 'Packed',
        preset: {
          ...initialFilter,
          shipment_status: ['packed'],
        },
      },
      {
        key: 'ready_to_ship',
        label: 'Ready To Ship',
        preset: {
          ...initialFilter,
          shipment_status: ['ready_to_ship'],
        },
      },
      {
        key: 'all',
        label: 'All',
        preset: {
          ...initialFilter,
          shipment_status: [
            'created',
            'picking',
            'picked',
            'sidelined',
            'packed',
            'ready_to_ship',
            'added_to_manifest',
            'dispatched',
            'delivered',
            'return_acknowledged',
            'returned',
          ],
          created_after: `${today}T00:00:00+05:30`,
          created_before: `${nextDayStr}T00:00:00+05:30`,
        },
      },
    ],
  };
};
